// @flow

import { useUserInputValue } from '@tectonics/prs/user-input-values';

const EWALLETS_REQUIRING_DOCUMENT = ['qr'];
const PAYMENT_METHODS_REQUIRING_DOCUMENT = ['qr'];

export function useArgentineEwalletDocumentForceShow(): boolean {
  const [selectedPaymentMethod] = useUserInputValue('selectedPaymentMethod');
  const [selectedEWallet] = useUserInputValue('selectedEWallet');

  if (PAYMENT_METHODS_REQUIRING_DOCUMENT.includes(selectedPaymentMethod)) {
    return true;
  }

  if (selectedPaymentMethod !== 'ewallet') {
    return false;
  }

  return EWALLETS_REQUIRING_DOCUMENT.includes(selectedEWallet);
}
